import { render, staticRenderFns } from "./StudentExamList.vue?vue&type=template&id=14ca1603"
import script from "./StudentExamList.vue?vue&type=script&lang=js"
export * from "./StudentExamList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports